'use client';

import React, { useState } from 'react';

const faqs = [
  {
    id: 'faq-001',
    question: 'What happens to my free temp address when I upgrade?',
    answer:
      'Your existing temp address stays active until it expires naturally. When you upgrade to Pro, you can immediately create a new permanent address on your chosen domain. Your free address and Pro address can both receive messages simultaneously during the transition.',
  },
  {
    id: 'faq-002',
    question: 'Can I choose my own username for a permanent address?',
    answer:
      'Yes. Pro and Business plans let you pick a custom username (e.g. alex@mailnova.io) as long as it is not already taken. Usernames must be 3–32 characters, letters and numbers only. You can change it once every 90 days.',
  },
  {
    id: 'faq-003',
    question: 'What domains are available for permanent addresses?',
    answer:
      'Pro plan includes mailnova.io, dropbox.email, and fastinbox.net. Business plan adds the ability to connect your own domain via DNS records, so your team can receive at yourcompany.com.',
  },
  {
    id: 'faq-004',
    question: 'Is the 1 GB free drive storage shared across addresses?',
    answer:
      'Yes. Storage is per account, not per address. All attachments received across all your active addresses count toward the same quota. Upgrading increases the total pool available to your account.',
  },
  {
    id: 'faq-005',
    question: 'How does the annual billing discount work?',
    answer:
      'Annual billing is charged as a single upfront payment covering 12 months. Pro annual costs $36/year ($3/mo effective) vs $48/year on monthly. Business annual costs $144/year ($12/mo effective) vs $192/year on monthly. You can switch between monthly and annual at any renewal date.',
  },
  {
    id: 'faq-006',
    question: 'Can I cancel at any time?',
    answer:
      'Yes. Cancel from your account settings at any time. Your paid features remain active until the end of your current billing period. After cancellation, permanent addresses revert to a 30-day grace period — they remain active but will expire unless you resubscribe.',
  },
  {
    id: 'faq-007',
    question: 'How fast is message delivery to my inbox?',
    answer:
      'Free and Pro inboxes receive messages within 1–3 seconds of the sending server delivering to our MX records. Business plan customers get priority queue processing, which maintains sub-1-second delivery even during high traffic periods. All delivery is powered by Resend infrastructure.',
  },
  {
    id: 'faq-008',
    question: 'Do you read or scan the contents of my emails?',
    answer:
      'No. Messages are stored encrypted at rest. We run spam and malware filtering on attachments for security purposes, but the content of your messages is never read, indexed for advertising, or shared with third parties. See our Privacy Policy for full details.',
  },
];

export default function FaqAccordion() {
  const [openId, setOpenId] = useState<string | null>('faq-001');

  return (
    <div className="space-y-2">
      {faqs?.map((faq) => {
        const isOpen = openId === faq?.id;
        return (
          <div
            key={faq?.id}
            className={`rounded-xl border transition-all duration-200 overflow-hidden ${
              isOpen ? 'border-primary/30 bg-primary/5' : 'border-border bg-card hover:border-border/80'
            }`}
          >
            <button
              onClick={() => setOpenId(isOpen ? null : faq?.id)}
              className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
              aria-expanded={isOpen}
            >
              <span className={`text-sm font-semibold leading-snug ${isOpen ? 'text-primary' : 'text-foreground'}`}>
                {faq?.question}
              </span>
              <span className={`flex-shrink-0 w-5 h-5 rounded-full border flex items-center justify-center transition-all duration-200 ${
                isOpen ? 'bg-primary/10 border-primary/30 rotate-180' : 'border-border'
              }`}>
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={isOpen ? 'var(--primary)' : 'currentColor'} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
            </button>
            {isOpen && (
              <div className="px-5 pb-4 animate-slide-up">
                <p className="text-sm text-secondary-foreground leading-relaxed">{faq?.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}